// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export type ProductDetailsZoomState = Toolkit.Store.Bunzl.Pages.ProductDetailsZoom.State;

export const initialProductDetailsZoomState: ProductDetailsZoomState = {
    isZoomOpen: false,
};

export const productDetailsZoomActions = {
    "Store/Pages/productDetailsZoom/setIsZoomOpen": (draft: Draft<ProductDetailsZoomState>, action: { isZoomOpen: boolean }) => {
        draft.isZoomOpen = action.isZoomOpen;
    },
};

const productDetailsZoomReducer = createTypedReducerWithImmer(initialProductDetailsZoomState, productDetailsZoomActions);
export type ProductDetailsZoomActions = Parameters<typeof productDetailsZoomReducer>[1];
export default productDetailsZoomReducer;